<dff-side [observable]="vm$">
  @if (vm$ | async; as vm) {
    <dff-side-titel id="qa-noter-titel-component">{{ vm.indstillinger.sideTitel }}</dff-side-titel>
    @if (progress$ | async; as progress) {
      <dff-upload-progress-overlay [value]="progress"></dff-upload-progress-overlay>
    }
    <note-liste
      [formArray]="vm.data.formArray"
      [omraader]="vm.data.omraader"
      [henvendelsestyper]="vm.data.henvendelsestyper"
      [opgavestyringStatusser]="vm.data.opgavestyringStatusser"
      [brugere]="vm.data.brugere"
      [defaultOmraadeId]="vm.data.defaultOmraadeId"
      [aktivNoteId]="vm.data.aktivNoteId"
      [hent]="hentNote"
      [gem]="gemNote"
      [slet]="sletNote"
      >
    </note-liste>
    @if (vm.data.formArray.length === 0) {
      <empty-page-badge svgIcon="noter-page-empty" overskrift="Her føles lidt tomt">
        <p>Du kan trykke på plus-knappen for at oprette en ny note</p>
      </empty-page-badge>
    }
  }
</dff-side>
